import { SellerDashboardPage, Card, CardContent } from "@b2b/ui-components";
import { useAuth } from "../../auth/Authprovider";
import { SellerStatus } from "@b2b/services";
import { AlertCircle, UserCircle, CreditCard, Store } from "lucide-react";
import { Link } from "react-router-dom";

const PROFILE_THRESHOLD = 80;

export default function SellerDashboardWrapper() {
  const {
    sellerStatus,
    profileCompletionPercentage,
    profileCompleteWithoutSocial,
    hasMembershipPlanSelected,
    storefrontComplete,
  } = useAuth();

  const profileCompleteEnough =
    (typeof profileCompletionPercentage === "number" && profileCompletionPercentage >= PROFILE_THRESHOLD) ||
    profileCompleteWithoutSocial === true;

  const allThreeStepsDone = profileCompleteEnough && hasMembershipPlanSelected && storefrontComplete;
  const pendingApproval = sellerStatus === SellerStatus.PENDING_APPROVAL || sellerStatus === null;

  return (
    <div className="space-y-6">
      {!profileCompleteEnough && (
        <div className="p-4">
          <Card className="bg-amber-50 border-amber-200">
            <CardContent className="p-4">
              <div className="flex items-start gap-3">
                <UserCircle className="h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                  <h3 className="text-amber-800 font-semibold text-base mb-1">
                    Step 1: Complete your profile
                  </h3>
                  <p className="text-amber-700 text-sm mb-2">
                    Reach 80% profile completion to unlock Membership Plans and more.
                    {typeof profileCompletionPercentage === "number" && (
                      <span className="font-medium ml-1">
                        Your progress: {profileCompletionPercentage}%
                      </span>
                    )}
                  </p>
                  <Link
                    to="/seller/profile_settings"
                    className="inline-flex items-center text-amber-800 font-medium text-sm hover:underline"
                  >
                    Go to Profile Settings →
                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
      {profileCompleteEnough && !hasMembershipPlanSelected && (
        <div className="p-4">
          <Card className="bg-amber-50 border-amber-200">
            <CardContent className="p-4">
              <div className="flex items-start gap-3">
                <CreditCard className="h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                  <h3 className="text-amber-800 font-semibold text-base mb-1">
                    Step 2: Select a membership plan
                  </h3>
                  <p className="text-amber-700 text-sm mb-2">
                    Choose a membership plan to unlock your Storefront and complete setup.
                  </p>
                  <Link
                    to="/seller/membership_plans"
                    className="inline-flex items-center text-amber-800 font-medium text-sm hover:underline"
                  >
                    Go to Membership Plans →
                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
      {profileCompleteEnough && hasMembershipPlanSelected && !storefrontComplete && (
        <div className="p-4">
          <Card className="bg-amber-50 border-amber-200">
            <CardContent className="p-4">
              <div className="flex items-start gap-3">
                <Store className="h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                  <h3 className="text-amber-800 font-semibold text-base mb-1">
                    Step 3: Complete your storefront
                  </h3>
                  <p className="text-amber-700 text-sm mb-2">
                    Set up your storefront (e.g. company description or SEO title) so it can be shown to buyers.
                  </p>
                  <Link
                    to="/seller/store_front"
                    className="inline-flex items-center text-amber-800 font-medium text-sm hover:underline"
                  >
                    Go to Storefront →
                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
      {profileCompleteEnough && allThreeStepsDone && pendingApproval && (
        <div className="p-4">
          <Card className="bg-yellow-50 border-yellow-200">
            <CardContent className="p-4">
              <div className="flex items-start gap-3">
                <AlertCircle className="h-5 w-5 text-yellow-600 mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                  <h3 className="text-yellow-800 font-semibold text-base mb-1">
                    Waiting for admin activation
                  </h3>
                  <p className="text-yellow-700 text-sm">
                    You have completed all setup steps. Full seller features will be available after an admin activates your account.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
      <SellerDashboardPage />
    </div>
  );
}